<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
      <template slot="publishStatusSlot" slot-scope="{ row }">
        <el-button @click="showPublishSpeed(row)" type="link" v-if="row.publishStatus == 0">{{publish_status_map[row.publishStatus]}}</el-button>
        <span v-else>{{publish_status_map[row.publishStatus]}}</span>
      </template>
      <template slot="shopNameSlot" slot-scope="{ row }">
        <el-image v-if="row.shopIcon" style="width: 18px; height: 18px" :src="row.shopIcon"></el-image>
        <span style="margin-left: 2px;flex: 1">{{ row.shopName}}</span>
      </template>
      <template slot="opcolsSlot" slot-scope="{ row }">
        <el-button
          type="link"
          @click="jumpDetail(row)"
          >查看明细</el-button
        >
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary.js";
import tableMixins from '@mixins/table-mixins';
import { mapActions, mapMutations, mapGetters} from "vuex";


export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    }
  },
  mixins: [new tableMixins(176,{ refName:'search' })],
  components: {
    TableList,
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters(['routerPrefix', 'getLogActiveName']),
    publish_status_map() {
      const { PUBLISH_STATUS_MAP }  = prod_center_dictionary;
      if(this.getLogActiveName === 'publishStoresLog') {
       PUBLISH_STATUS_MAP[0] = '推送中';
      }
      return PUBLISH_STATUS_MAP;
    },
    cols() {
      if(this.getLogActiveName === 'publishStoresLog') {
        return [
          { prop: "publishTime", attrs: { label: "推送时间" } },
          { prop: "shopName", attrs: { label: "推送店铺" },slot: true },
          { prop: "publishStatus", attrs: { label: "状态" },slot: true },
          { prop: "staffName", attrs: { label: "操作人" } },
          { prop: "publishTotal", attrs: { label: "商品总数" } },
          { prop: "successTotal", attrs: { label: "成功数" } },
          { prop: "failureTotal", attrs: { label: "失败数" } },
          { prop: "otherReasonTotal", attrs: { label: "其他原因数" } },
          { prop: "opcols", attrs: { label: "操作" }, slot: true }
        ];
      }
      return  [
        { prop: "publishTime", attrs: { label: "铺货时间" } },
        { prop: "shopName", attrs: { label: "铺货店铺" },slot: true },
        { prop: "publishStatus", attrs: { label: "铺货状态" },slot: true },
        { prop: "staffName", attrs: { label: "铺货人" } },
        { prop: "publishTotal", attrs: { label: "铺货总数" } },
        { prop: "successTotal", attrs: { label: "铺货成功数" } },
        { prop: "failureTotal", attrs: { label: "铺货失败数" } },
        { prop: "otherReasonTotal", attrs: { label: "其他原因数" } },
        { prop: "opcols", attrs: { label: "操作" }, slot: true }
      ];
    }
  },
  methods: {
    ...mapActions(['publishSpeed']),
    ...mapMutations(['setCurrentPage']),
    jumpDetail(rowData) {
      console.log(rowData, `${this.routerPrefix}prod_log`, '查看明细');
       this.$router.push({
          name: `${this.routerPrefix}prod_log`,
          query:{
            id: rowData.id,
            platformType: rowData.platformType,
          }
      })
    },
    showPublishSpeed(rowData) {
      this.setCurrentPage(`${this.routerPrefix}log`);
      this.publishSpeed({publishType: rowData.publishType, resultVisible: true, batchTaskId: rowData.batchTaskId})
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
